/**
 * Representation of Accordion element
 */
export class AccordionItem {
  public icon: string;
  public label: string;
  public content: string;
  private _isOpened: boolean;

  constructor(icon: string, label: string, content: string) {
    this.icon = icon;
    this.label = label;
    this.content = content;
    this._isOpened = false;
  }
  public switch() {
    this._isOpened = !this._isOpened;
  }
  public open() {
    this._isOpened = true;
  }
  public close() {
    this._isOpened = false;
  }
  get isOpened(): boolean {
    return this._isOpened;
  }

  set isOpened(value: boolean) {
    this._isOpened = value;
  }
  public getStatus(): string {
    return this._isOpened ? 'open' : 'close';
  }
}
